module.exports = __webpack_public_path__ + "media/images/riders/BENOIT_COULANGES-1c61d4d37646ce8cfc20a05d6d9984ac.png";